// REMINDER: Please do not commit changes inside the object. Thanks!

// used to hardcode override values for local development
// also used to prevent reloading of a flag from remote changes
// example:

export default {
  // NOTE: uncomment the next line to enable MS program flex:
  // 'feature-learn-18843-ms-program-flex': true,
  // NOTE: uncomment the next line to enable site selection in Middle School:
  // 'feature_LEARN-20108-ms-site-selection': true,
  // NOTE: uncomment the next line to enable site selection in K5 digital:
  // 'feature_LEARN-20164-k5-site-selection': true,
  // NOTE: uncomment the next line to *disable* SSAPI v4 calls (flag is on in DEV):
  // 'feature_LEARN-24754_educator_journey_updates': false,
  // 'feature_LEARN-23137_add-tiered-interventions-to-learn': true,
  // NOTE: uncomment the next line to enable experience player in learn:
  // 'feature_LEARN-26293-experience-player-in-learn': true,
  // 'feature_LEARN-27700_core-lesson-completion-updates': true,
  // 'feature_LEARN-27700_specialized-lesson-completion-updates': true,
  // 'feature_LEARN-25819_leaderDashboardRedesign': true,
  // 'feature_LEARN-28194-recent-activities': true,
  // NOTE: uncomment the next line to enable lesson page update:
  // 'feature_LEARN-28473-learn-k12-core-curriculum-service-integration': true,
  // NOTE: uncomment the next line to use curriculum service for content fetching:
  // 'feature_LEARN-26260-curriculum-content': true,
}
